<template>
  <div>
    <h1 class="mb-8 font-bold text-3xl">
      <inertia-link style="color: #FF6D23;" class="text-black hover:text-black-600" :href="route('organizations')">Agencia</inertia-link>
      <span class="text-black-400 font-medium">/</span> Crear
    </h1>
    <div class="bg-white rounded-md shadow overflow-hidden max-w-3xl">
      <form @submit.prevent="store">
        <div class="p-8 -mr-6 -mb-8 flex flex-wrap">
          <text-input v-model="form.name" :error="form.errors.name" class="pr-6 pb-8 w-full lg:w-2/2" label="Nombre Agencia" required/>
           </div>
        <div class="px-8 py-4 bg-transparent flex justify-end items-center">
          <loading-button :loading="form.processing" style="color: black;" class="px-20 py-7 btn-indigoOrangedos" type="submit">CREAR AGENCIA</loading-button>
        </div>
      </form>
    </div>
  </div>
</template>

<script>
import Layout from '@/Shared/Layout'
import TextInput from '@/Shared/TextInput'
import SelectInput from '@/Shared/SelectInput'
import LoadingButton from '@/Shared/LoadingButton'

export default {
  metaInfo: { title: 'Create Organization' },
  components: {
    LoadingButton,
    SelectInput,
    TextInput,
  },
  layout: Layout,
  remember: 'form',
  data() {
    return {
      form: this.$inertia.form({
        name: null,
        email: null,
        phone: null,
        address: null,
        city: null,
        region: null,
        country: null,
        postal_code: null,
      }),
    }
  },
  methods: {
    store() {
      this.form.post(this.route('organizations.store'))
    },
  },
}
</script>
